import { addScript } from '@tunein/web-utils';

// The URL loadStripe adds and looks for, so the payment page's loadStripe call reuses this load.
const STRIPE_JS_URL = 'https://js.stripe.com/v3';

/** Whether Stripe.js is on the page, loaded or still loading. */
export function isStripeJsOnPage() {
  return Boolean(document.querySelector(`script[src^="${STRIPE_JS_URL}"]`));
}

/**
 * Starts loading Stripe.js before the payment page asks for it, so the page doesn't wait on it and
 * Stripe's fraud signals start before checkout.
 */
export function preloadStripeJs() {
  if (typeof document === 'undefined' || isStripeJsOnPage()) {
    return;
  }

  addScript({ src: STRIPE_JS_URL, async: true, appendTo: 'head' }).catch(() => {
    // loadStripe waits on a script it finds on the page, and a script that already failed never
    // fires again, so a failed preload is removed to let loadStripe add its own.
    document.querySelector(`script[src="${STRIPE_JS_URL}"]`)?.remove();
  });
}
